import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
});

// Interceptor odpowiedzi
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403 || !error.response) {
            localStorage.removeItem('tokenAdmin');
            window.location.href = '/adminPanel';
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default api;
